<!-- BANNER -->
<template>
  <div class="policy_ifno">
    <div class="home_banner fd_column">
      <div class="component_box" style="background: #E0EDFF;">
        <div class="banner_bg" :style="{ backgroundImage: `url(${bg})` }">
          <div class="banner_text">
            <div class="banner_content">
              <div>重新定义</div>
              <div>艺术品购买定制流程</div>
              <div>打造体验升级的极致感受</div>
            </div>
            <div class="banner_btn">
              <div @click="linkJump(1, '/Artbuying')">艺术品租赁及购买</div>
              <div @click="linkJump(1, '/Example')">艺术品定制</div>
            </div>
          </div>
        </div>
        <!-- 移动端 -->
        <div
          class="mobile_banner_bg"
          :style="{ backgroundImage: `url(${bg1})` }"
        >
          <div class="banner_content">
            <div>重新定义</div>
            <div>艺术品购买定制流程</div>
            <div>打造体验升级的极致感受</div>
          </div>
          <div class="Custom_purchase">
            <div
              :style="{ backgroundImage: `url(${bg2})` }"
              @click="linkJump(2, '/Artbuying')"
            >
              艺术品租赁及购买
            </div>
            <div
              :style="{ backgroundImage: `url(${bg3})` }"
              @click="linkJump(2, '/Example')"
            >
              艺术品定制
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      swiper: null,
      bg: require("@/assets/home/Banner/banner_bg.png"),
      bg1: require("@/assets/home/Banner/mobile_banner.png"),
      bg2: require("@/assets/home/Banner/purchase.png"),
      bg3: require("@/assets/home/Banner/customization.png"),
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
@import "~@/static/styles/variables.less";
@import "~@/static/styles/index.less";
// @import url(); 引入公共css类
.component_title {
  margin-bottom: 25.0012px;
}
.policy_ifno {
  position: relative;
  width: 100%;
  .policy_ifno_box {
    justify-content: space-between;
    width: @defaultWidth;
    margin: 0 auto;
  }
  .title {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    font-size: 19.9988px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #262626;
    line-height: 27px;
    .subtitle {
      margin-top: 7.9987px;
      font-size: 13.9988px;
      font-family: PingFang-SC-Light, PingFang-SC;
      font-weight: 300;
      color: #262626;
      line-height: 27px;
    }
  }
  .content {
    width: 880.0013px;
    justify-content: flex-end;
    flex-wrap: wrap;
    .link_item {
      padding: 7.9987px 15px;
      img {
        width: 13.0013px;
        height: 13.0013px;
        margin-right: 7.9987px;
      }
      font-size: 13.9988px;
      font-family: PingFang-SC-Regular, PingFang-SC;
      font-weight: 400;
      color: #666666;
      line-height: 19.0013px;
      border-radius: 4.9988px;

      &:hover {
        background-color: #fff;
        color: @mainColor;
        box-shadow: 0px 3px 16.0013px -7.9987px rgba(101, 101, 101, 0.21);
      }
    }
  }
  .banner_bg {
    width: 100%;
    background-size: 100% 100%;
    height: 5.026rem;
    .banner_text {
      display: flex;
      flex-direction: column;
      position: absolute;
      left: 1.25rem;
      top: 1.5104rem;
      .banner_content {
        font-weight: 500;
        font-size: 0.2708rem;
        color: #333333;
        line-height: 0.4479rem;
        text-align: left;
        font-family: Source-Medium;
      }
    }
    .banner_btn {
      display: flex;
      align-items: center;
      gap: 0.1042rem;
      margin-top: 0.3125rem;
      :first-child {
        width: 0.9688rem;
        height: 0.3125rem;
        background: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
        border-radius: 0.0625rem 0.0625rem 0.0625rem 0.0625rem;
        font-weight: 400;
        font-size: 0.0833rem;
        color: #ffffff;
        line-height: 0.3021rem;
        text-align: center;
        cursor: pointer;
      }
      :last-child {
        width: 0.9583rem;
        height: 0.3021rem;
        border-radius: 0.0625rem 0.0625rem 0.0625rem 0.0625rem;
        border: 0.0052rem solid #166df0;
        font-weight: 400;
        font-size: 0.0833rem;
        color: #166df0;
        line-height: 0.3021rem;
        text-align: center;
        cursor: pointer;
      }
    }
  }
  .mobile_banner_bg {
    width: 100%;
    height: 17.5rem;
    background-size: 100% 100%;
    .Custom_purchase {
      display: flex;
      align-items: center;
      padding: 0 0.4rem;
      position: absolute;
      bottom: -1.7067rem;
      justify-content: space-between;
      :first-child {
        margin-right: 0.2667rem;
      }
      div {
        width: 4.48rem;
        height: 2.5067rem;
        font-family: Source-Regular;
        font-weight: 400;
        font-size: 0.3467rem;
        text-align: center;
        color: #ffffff;
        background-size: 100% 100%;
        line-height: 2.5067rem;
      }
    }
  }
  @media screen and (max-width: 1024px) {
    .banner_bg {
      display: none;
    }
    .banner_content {
      font-size: 0.6667rem;
      position: absolute;
      top: 2.6667rem;
      left: 1.3333rem;
      text-align: center;
      line-height: 1.04rem;
    }
  }
  @media screen and (min-width: 1024px) {
    .mobile_banner_bg {
      display: none;
    }
  }
}

.component_box {
  .normal_flex;
}
.home_banner {
  .policy_list {
    height: 106.0013px;
    border-radius: 10.0012px;
    position: absolute;
    bottom: -73.0012px;
    left: 50%;
    background: rgba(255, 255, 255, 0.85);
    box-shadow: 0px 4.0012px 24px 0px rgba(0, 0, 0, 0.1);
    transform: translateX(-50%);
    z-index: 999;
    .normal_flex;
    width: @commentWidth;
    margin: 0 auto;
    &::before {
      content: "";
      position: absolute;
      z-index: 0;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 10.0012px;
      background-color: rgba(255, 255, 255, 0.5);
      backdrop-filter: blur(10.0012px);
      opacity: 0.8;
    }
    .dropdown {
      cursor: pointer;
      .dropdown-content {
        /* 隐藏元素 */
        display: none;
        position: absolute;
        background-color: #f9f9f9;
        width: 100%;
        top: 60px;
        padding: 10.0012px 0;
        box-shadow: 0px 7.9987px 16.0013px 0px rgba(0, 0, 0, 0.2);
      }

      .dropdown-content a {
        text-align: center;
        padding: 19.9988px;
        font-size: 16.0013px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #646566;
        line-height: 19.0013px;
        text-decoration: none;
        display: block;
      }

      .dropdown-content a:hover {
        color: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
      }

      /* .dropdown的hover效果，作用在.dropdown-content上 */
      &:hover .dropdown-content {
        display: block;
      }
    }
    .policy_item_box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      z-index: 1;
      &:last-child {
        .policy_item_bar {
          border-right: 0;
        }
      }
    }
    .policy_item_bar {
      height: 49.9987px;
      border-right: 1.0012px solid #efefef;
    }
    .policy_item {
      z-index: 1;
      width: 192px;
      height: 49.9987px;
      box-sizing: border-box;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      background-color: transparent;
      transition: all 0.3s;
      gap: 6px;
      // backdrop-filter: blur(30px); //毛玻璃属性
      // &:hover {
      //   background: linear-gradient( 90deg, #68A4FF 0%, #166DF0 100%) ;
      //   // .title {
      //   //   color: linear-gradient( 90deg, #68A4FF 0%, #166DF0 100%) ;
      //   // }
      //   .label {
      //     color: #0c2879;
      //   }
      // }
      &:hover {
        transform: scale(1.1);
      }

      .title_img {
        width: 46.0012px;
        height: 46.0012px;
        object-fit: contain;
      }
      .title {
        font-size: 18px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #000000;
        line-height: 19.0013px;
        line-height: 34.9988px;
        span {
          margin-left: 9px;
          font-size: 13.9988px;
          font-family: PingFang-SC-Regular, PingFang-SC;
          font-weight: 400;
          color: #0c2879;
          line-height: 19.9988px;
        }
      }
      .label {
        font-size: 13.9988px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: 400;
        color: #0c2879;
        line-height: 19.9988px;
      }
      &:first-child {
        padding-left: 0;
      }
      &:last-child {
        padding-right: 0;
      }
    }
  }
  .component_box {
    width: 100%;
    justify-content: space-between;
    gap: 19.9988px;
    .news_item {
      box-sizing: border-box;
      position: relative;
      background-repeat: no-repeat;
      background-size: 100% auto;
      // background-color: rgb(187, 41, 41);
      box-shadow: 0px 3px 16.0013px -7.9987px rgba(101, 101, 101, 0.21);
      width: 100%;
      height: auto;
      img {
        width: 100%;
        max-height: 600px;
        object-fit: fill;
      }
      .text_box {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 10.0012px;
        .big_title {
          font-size: 40.0012px;
          font-family: Source Han Sans SC-Medium, Source Han Sans SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 46.9988px;
        }
        .sub_title {
          font-size: 30px;
          font-family: Source Han Sans SC-Regular, Source Han Sans SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 21px;
        }
      }
      .date {
        font-size: 25.9988px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        // color: #ffffff;
        line-height: 30px;
      }
      .date_year {
        font-size: 16.0013px;
        font-family: Roboto-Light, Roboto;
        font-weight: 300;
        // color: #ffffff;
        line-height: 19.0013px;
      }
      .mask_box {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 12px 31.9987px;
        position: absolute;
        bottom: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.1);
        height: 78px;
        width: 100%;
        .title {
          font-size: 16.0013px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 22.9987px;
        }
        .cat {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .cat_item {
            padding: 0 16.9987px;
            background: #ff5048;
            border-radius: 1.9988px;
            font-size: 12px;
            font-family: PingFang-SC-Medium, PingFang-SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 27px;
          }
        }
      }
    }
  }
  /*包裹自定义分页器的div的位置等CSS样式*/
}
</style>
<style lang="less">
.home_banner {
  .swiper-horizontal {
    .swiper-control {
      // width: 100%;
      z-index: 99;
      position: absolute;
      bottom: 13.0013px;
      left: 50%;
      transform: translate(-50%, 0);
      width: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      .button-prev,
      .button-next {
        cursor: pointer;
        position: relative;
        z-index: 1;
        margin: 0 16.0013px;
      }

      .swiper-pagination-bullets {
        position: relative;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        .swiper-pagination-bullet {
          box-sizing: border-box;
          margin: 0 16.0013px !important;
          width: 19.9988px;
          height: 19.9988px;
          background-color: transparent;
          border-radius: 19.9988px;
          border: 1.0012px solid transparent;
          display: flex;
          justify-content: center;
          align-items: center;
          opacity: 1;
          .customs_inner {
            width: 7.9987px;
            height: 7.9987px;
            display: inline-block;
            background: #020202;
            opacity: 0.5;
            border-radius: 4.0012px;
          }
        }
        .swiper-pagination-bullet-active {
          border: 1.0012px solid #020202;
          .customs_inner {
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>
